module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_add-to-unscopables.js
// module id = 602
// module chunks = 168707334958949